import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { BranchDetailView } from "@/views/branch-detail/branch-detail.view";
import { Redirect, Route, Switch } from "wouter";
import { BranchView } from "./branch.view";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";

export function BranchRoutes() {
  const ability = useAbility();
  const branchUpdateUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const branchDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });
  const canManage = ability.can(Action.Manage, "Branch");

  return (
    <Switch>
      <Route path={"/create"} component={canManage ? CreateView : ReadOnlyRedirect} />
      <Route path={branchUpdateUuidRegex} component={canManage ? UpdateView : ReadOnlyRedirect} />
      <Route path={branchDetailUuidRegex} component={BranchDetailView} />
      <Route path={"/"} component={BranchView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}

function ReadOnlyRedirect() {
  return <Redirect to="/" replace />;
}
